import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import { Link as RouterLink } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTheme, SxProps, Theme } from '@mui/material/styles';
// eslint-disable-next-line import/no-extraneous-dependencies
import { LocationDescriptorObject } from 'history';

export interface BreadcrumbsProps {
  breadcrumbLabels: string[];
  styleOverrides?: SxProps<Theme> | undefined;
  linkLocationOverride?: string | LocationDescriptorObject;
}

export interface BreadcrumbLinkProps {
  linkLabel: string;
  linkLocation: string | LocationDescriptorObject;
  lastLink: boolean;
}

function BreadcrumbLink(props: BreadcrumbLinkProps) {
  const theme = useTheme();
  const { linkLabel, linkLocation, lastLink } = props;

  return lastLink ? (
    <Typography component='a' aria-current='page' color='text.primary' variant='overline' data-testid={`${linkLabel}`}>
      {linkLabel.toUpperCase()}
    </Typography>
  ) : (
    <Typography
      component={RouterLink}
      to={linkLocation}
      variant='overline'
      sx={{
        textDecoration: 'none',
        color: theme.palette.primary.main,
      }}
      data-testid={`${linkLabel}`}
    >
      {linkLabel.toUpperCase()}
    </Typography>
  );
}

function Breadcrumbs(props: BreadcrumbsProps) {
  const { breadcrumbLabels, styleOverrides = {}, linkLocationOverride } = props;
  const lastElementIndex = breadcrumbLabels.length - 1;
  return (
    <MuiBreadcrumbs
      aria-label='breadcrumb'
      separator={<Typography variant='overline'>/</Typography>}
      sx={{
        pb: 2,
        pl: { xs: 3, xl: 4 },
        ...styleOverrides,
      }}
    >
      {breadcrumbLabels.map((label, index, labelsArr) => (
        <BreadcrumbLink
          key={`${label}${index.toString()}`}
          linkLabel={label}
          linkLocation={linkLocationOverride || '.'.repeat(labelsArr.length - index)}
          lastLink={index === lastElementIndex}
        />
      ))}
    </MuiBreadcrumbs>
  );
}

Breadcrumbs.defaultProps = {
  linkLocationOverride: undefined,
  styleOverrides: undefined,
};

export default Breadcrumbs;
